import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ItemComponent } from '@tecalisdev/infinity';

/**
 * Bloque «Configuración avanzada» del editor (NIF-845). Envuelve `tec-item` collapse.
 */
@Component({
	selector: 'app-workflow-form-advanced-collapse',
	imports: [ItemComponent, TranslatePipe],
	template: `
		<tec-item [title]="'WORKFLOWS.FORM.CONF_ADVANCED' | translate" collapse [expanded]="expanded">
			<ng-content />
		</tec-item>
	`,
})
export class WorkflowFormAdvancedCollapseComponent {
	@Input() public expanded: string | boolean | null | undefined;
}
